import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import LearningCenterDetails from '../learning-center-details';
import actions from 'api/actions';
import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import styles from '../styles.module.scss';

class LearningCenterDetailsSlugWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    actions.get('learning_centers')
      .then(r => this.setState({ allCenters: r.data }));
  }

  render() {
    const { ulcSlugOrId } = this.props.match.params;
    const { allCenters } = this.state;

    if (!allCenters) {
      return (
        <div className={styles.loadingSpinner}>
          <BeatLoader size={75} />
        </div>
      );
    }

    const foundLearningCenter = _.find(allCenters, center => {
      if (parseInt(ulcSlugOrId, 10) === parseInt(center.id, 10)) { return true; }

      const slugsForCenter = center.slugs.filter(slug => slug.slug_text === ulcSlugOrId);

      if (slugsForCenter && slugsForCenter.length > 0) {
        return true;
      }

      return false;
    });

    if (!foundLearningCenter) {
      return <Redirect to="/unyted-learning-centers" />;
    }

    return (
      <LearningCenterDetails
        learningCenterId={foundLearningCenter.id}
        allCenters={allCenters}
        {...this.props}
      />
    );
  }
}

export default LearningCenterDetailsSlugWrapper;
